import { createNavigationContainerRef } from '@react-navigation/native';
import type { RootStackParamList } from '../../types/RootStackParamList';

/**
 * 컴포넌트 밖(예: bridge 유틸 클래스)에서 imperative 하게 네비게이션하기 위한 전역 ref.
 *
 * `NavigationContainer` 의 `ref` 로 연결해야 동작하며, 호출 전 `isReady()` 로 준비
 * 여부를 확인한다. (RN-web 은 `apps/ably-web` 의 NavigationContainer 에 연결)
 */
export const navigationRef = createNavigationContainerRef<RootStackParamList>();
